import cookie from 'cookie_js';
import lazySizes from 'lazysizes';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';

if (window) {
    // Init libraries that aren't automatic
    window['cookie'] = window['cookie'] || cookie;
    window.lazySizesConfig = lazySizes.cfg;
}
